"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledMenuContentWrapper = exports.StyledMenu = exports.StyledAction = void 0;
const ui_components_1 = require("@groupby/ui-components");
const material_1 = require("@mui/material");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledAction = (0, styled_components_1.default)(ui_components_1.Button) `
  white-space: nowrap;

  &.menu--open {
    color: ${({ theme }) => theme.palette.primary.dark};
    background-color: ${ui_components_1.baseColors.primaryAccentGreen800};
    border-color: currentColor;
  }
`;
exports.StyledMenu = (0, styled_components_1.default)(material_1.Menu) `
  .MuiPaper-root {
    box-sizing: border-box;
    max-width: 400px;
    min-width: 150px;
    padding: ${({ theme }) => theme.spacing(1)};;
    border-radius: 8px;
    color: ${ui_components_1.baseColors.primaryBlueDark500};
    margin-top: 12px;
    text-align: center;
    max-height: 500px;
    z-index: 1400;
    overflow-y: auto;
    overflow-x: hidden;
    box-shadow: ${ui_components_1.shadows.appMenu};
  }

  & .MuiList-root {
    display: flex;
  }
`;
exports.StyledMenuContentWrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  flex: 1;

  .MuiMenuItem-root {
    border-radius: 4px;
    margin: 0;
  }
`;
